import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71353fbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login_wrap" }
const _hoisted_2 = { class: "login" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "注册账号", -1))
const _hoisted_4 = {
  key: 0,
  class: "wrap_form"
}
const _hoisted_5 = { class: "wrap_form_center" }
const _hoisted_6 = { class: "form_item" }
const _hoisted_7 = { class: "wrap_form_center" }
const _hoisted_8 = { class: "form_item" }
const _hoisted_9 = { class: "wrap_form_center" }
const _hoisted_10 = { class: "form_item" }
const _hoisted_11 = { class: "wrap_form_btn" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "awsc" }, null, -1))
const _hoisted_13 = { class: "wrap_active" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "《隐私协议》", -1))
const _hoisted_15 = { class: "wrap_button" }
const _hoisted_16 = { class: "wrap_active_visible" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_CheckOutlined = _resolveComponent("CheckOutlined")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_PrivacyPolicy = _resolveComponent("PrivacyPolicy")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "content_box",
        style: _normalizeStyle(_ctx.getDisplay() ? 'margin-top: 30px' : '')
      }, [
        _hoisted_3,
        (_ctx.isShowform)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_a_input, {
                    class: "form_item_name",
                    value: _ctx.formData.name,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                    placeholder: "请输入用户名",
                    onPressEnter: _ctx.rules,
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.name = _ctx.formData.name.replace(/[^\u4e00-\u9fa5_a-zA-Z0-9]+/g, ''))),
                    onBlur: _ctx.rules
                  }, null, 8, ["value", "onPressEnter", "onBlur"])
                ]),
                _withDirectives(_createVNode(_component_CheckOutlined, { class: "wrap_form_top_icon" }, null, 512), [
                  [_vShow, _ctx.showYes]
                ])
              ]),
              _createElementVNode("div", {
                class: "wrap_form_top_name",
                style: _normalizeStyle({ color: _ctx.nameText ? '#ff4d4f' : '#9aa1a9' })
              }, _toDisplayString(_ctx.nameText ? _ctx.nameText : '6~18位字符，只能包含中文、英文字母、数字、下划线。'), 5),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_a_input, {
                    class: "form_item_name",
                    value: _ctx.formData.username,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.username) = $event)),
                    placeholder: "请输入手机号",
                    onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;"
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_a_input, {
                    class: "form_item_name",
                    value: _ctx.formData.code,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.code) = $event)),
                    placeholder: "请输入验证码",
                    onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;"
                  }, null, 8, ["value"]),
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("button", {
                      class: "wrap_form_button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getCode()))
                    }, "获取验证码", 512), [
                      [_vShow, _ctx.isShowcode]
                    ]),
                    _withDirectives(_createElementVNode("span", { class: "wrap_form_vaild" }, " 获取验证码(" + _toDisplayString(_ctx.count) + ") ", 513), [
                      [_vShow, !_ctx.isShowcode]
                    ])
                  ])
                ])
              ]),
              _hoisted_12
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_a_checkbox, {
            class: "wrap_active_checkbox",
            checked: _ctx.checkedalt,
            "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.checkedalt) = $event))
          }, null, 8, ["checked"]),
          _createElementVNode("span", {
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showModal && _ctx.showModal(...args))),
            class: "wrap_active_span"
          }, [
            _createTextVNode(" 条款阅读并同意"),
            _hoisted_14
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.register()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("注册")
            ]),
            _: 1
          }),
          _createElementVNode("p", null, [
            _createTextVNode("已有账号去"),
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.jump()))
            }, "登录")
          ])
        ])
      ], 4),
      _createVNode(_component_a_modal, {
        visible: _ctx.visible,
        "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.visible) = $event)),
        onOk: _ctx.handleOk,
        footer: null
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_PrivacyPolicy)
          ])
        ]),
        _: 1
      }, 8, ["visible", "onOk"])
    ])
  ]))
}